import styled from 'styled-components';

import { breakpoint } from '@/themes/breakpoints';

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 40px 0 80px;

  div[data-youtube-video] {
    iframe {
      width: calc(100vw - 32px);
      height: calc((100vw - 32px) * 0.75);

      @media ${breakpoint.sm} {
        width: 522px;
        height: 332px;
      }

      @media ${breakpoint.md} {
        width: 628px;
        height: 400px;
      }

      @media ${breakpoint.lg} {
        width: 868px;
        height: 601px;
      }
    }
  }
`;

export const FeaturedArticles = styled.div`
  display: flex;
  flex-direction: column;
  padding: 40px 0;
  background-color: ${({ theme: { colors } }) => colors.neutral[200]};

  @media ${breakpoint.sm} {
    padding: 40px 0;
  }

  @media ${breakpoint.md} {
    padding: 80px 0;
  }
`;

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SocialShareWrapper = styled.div`
  align-self: center;
  width: 100%;
  border-top: 1px solid ${({ theme: { colors } }) => colors.neutral[300]};
  padding-top: 60px;

  @media ${breakpoint.md} {
    width: 628px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  @media ${breakpoint.sm} {
    width: 522px;
  }

  @media ${breakpoint.md} {
    width: 628px;
  }

  @media ${breakpoint.lg} {
    width: 868px;
  }
`;
